export const DASHBOARD_CARD_MAX_ITEMS = 5;
